import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LegalFooterComponent } from '../shared/legal-footer/legal-footer.component';

@Component({
  selector: 'app-cookies',
  standalone: true,
  imports: [CommonModule, RouterModule, LegalFooterComponent],
  templateUrl: './cookies.component.html',
  styleUrls: ['../shared/legal-pages.styles.scss']
})
export class CookiesComponent {
  currentDate = new Date();

  constructor(private router: Router) {}

  goBack(): void {
    this.router.navigate(['/']);
  }
}